import {observer} from "mobx-react-lite"
import React from "react"
import AsyncSelect from "react-select/async"
import valueOutput from "../store/entities/ValueOutput"
import {selectStyler} from "./SelectStyler";

export interface AdapterOption {
    label: string,
    value: string,
    adapterType: string
}

export const AsyncAdaptersSelection = observer(({
                                                    destination,
                                                    onChange
                                                }: { destination: valueOutput, onChange?: () => void }) => {

    return <AsyncSelect<AdapterOption>
        placeholder={"Выбрать..."}
        {...selectStyler}
        defaultValue={destination.defaultOption}
        isClearable
        onChange={(value) => {
            if (value) {
                destination.setRuleAndSave(value.adapterType, value.value, value.label)?.then(() => {
                    if (onChange) {
                        onChange()
                    }
                })
            } else {
                destination.deleteDestination().then(() => {
                    if (onChange) {
                        onChange()
                    }
                })
            }

        }
        }
        defaultOptions={destination.defaultOptions}
    />
})

